<template>
  <div class="welcome wbg">
    <div class="top" v-if='$common.AUTH("Infomation")'>
      <a-row class="row" :gutter="20">
        <!--   <a-col class="flex" :span="4">
      <label>案件类型：</label>
          <a-select v-model="form.cause_type" placeholder="请选择" class="select">
            <a-select-option :value="''">全部</a-select-option>
            <a-select-option :value="1">诉讼</a-select-option>
            <a-select-option :value="2">仲裁</a-select-option>
          </a-select>
        </a-col> -->
        <a-col class="flex" :span="5">
          <label>当事人：</label>
          <a-input placeholder='请输入当事人姓名' v-model='form.debtor_name'> </a-input>
        </a-col>
        <a-col class="flex" :span="6">
          <label>证件号码/代码：</label>
          <a-input placeholder='请输入证件号码/代码' v-model='form.debtor_chinaid'></a-input>
        </a-col>
        <!-- <a-col class="flex" :span="5">
          <label>案号：</label>
          <a-input placeholder='请输入对应案号' v-model='form.no'></a-input>
        </a-col> -->
        <a-col class="flex" :span="6">
          <a-button icon="search" @click='form.page = 1; getList()' style="height:32px;">查询</a-button>
          <a-button @click='reset' style="height:32px;margin-left: 20px;">重置</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="tcon">
      <div class="tableList" v-if='$common.AUTH("Infomation")'>
        <div class="table">
          <table>
            <thead>
              <td width='70'>序号</td>
              <td width='70'>被告</td>
              <td width='160'>证件号码/代码</td>
              <td width="65">所属案件</td>
              <td width="65">案件类型</td>
              <td width="205">原告</td>
              <td width='190'>案号</td>
              <td width='210'>管辖法院/调解中心</td>
              <td width='100'>录入日期</td>
            </thead>
            <tbody>
              <tr v-for='(i, index) in data' :key='index'>
                <td>{{ 10 * (form.page - 1) + index + 1 }}</td>
                <td>
                  <span @click='dbclick(i)' class="curpoter">
                    <Normap :tit='i.realname'>{{ i.realname }}</Normap>
                  </span>
                </td>
                <td>
                  <p>
                    <Normap :tit='i.chinaid'>{{ i.chinaid }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for='j in i.cause' :key="j.id">
                    案件{{ j.sort }}
                  </p>
                </td>
                <td>
                  <p v-for='j in i.cause' :key="j.id">
                    {{ j.cause_type == 1 ? '诉讼' : j.cause_type == 2 ? '仲裁' : j.cause_type == 3 ? '公证' : j.cause_type ==
                    1 ? '调解' : '/' }}
                  </p>
                </td>
                <td>
                  <p v-for='j in i.cause' :key="j.id">
                    <Normap :tit='j.accuser.title'>{{ j.accuser.title }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for="j in i.cause" :key="j.id">
                    <span v-if='j.no'>
                      <Normap :tit='j.no'>{{ i.no }}</Normap>
                    </span>
                    <span v-else>/</span>
                  </p>
                </td>
                <td>
                  <p v-for="j in i.cause" :key="j.id">
                    <span v-if='j.court'>
                      <Normap :tit='j.court'>{{ j.court }}</Normap>
                    </span>
                    <span v-else>/</span>
                  </p>
                </td>
                <td>
                  <p v-for='j in i.cause' :key="j.id">
                    <Normap :tit='j.create_time | yearFormat'>{{ j.create_time | yearFormat }}</Normap>
                  </p>
                </td>
                <!-- <td>
                  <a href="javascript:vold(0);" @click='dbclick(i)'>查看</a>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pages">
          <a-pagination v-model="form.page" show-quick-jumper :total="total" show-less-items :pageSize='10'
            @change='turnpage' :show-total="(total) => `被告：${total} `" />
        </div>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import TableBox from "@/components/table"
import { shareList } from '@/server/debtor'
export default {
  data() {
    return {
      data: [],
      modify: null,
      time: null,
      page: {
        current: 1,
        pageSize: 10,
        showQuickJumper: true,
        showSizeChanger: false,
        total: 0
      },
      form: {
        limit: 10,
        page: 1,
        debtor_name: '',
        debtor_chinaid: '',
        cause_type: '',
        cause_no: ''
      },
      total: 0,
      cause_count: null,
      modalVisible: false,

      seeType: 0,
      seeTitle: ''
    }
  },
  created() {
    this.getList()
  },
  components: {
    TableBox
  },
  mounted() {
    let _this = this
    document.onkeydown = function (e) {
      if (e.keyCode == 13) {
        _this.getList()
      }
    }
  },
  methods: {
    dbclick(record) {
      if (this.$common.AUTH('Infomation')) {
        let routeUrl = this.$router.resolve({ "name": "InDetails", params: { "id": record.id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    turnpage(val) {
      this.form.page = val;
      this.getList({ current: val })
    },
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.form.debtor_name = ''
      this.form.debtor_chinaid = ''
      this.getList()
    },
    getList(val) {
      let form = JSON.parse(JSON.stringify(this.form))
      if (typeof val === 'object') {
        this.page.current = val.current
        form.page = val.current
      } else {
        this.page.current = 1
        form.page = 1
      }
      shareList(form).then(e => {
        this.total = e.count
        this.data = e.list
        this.page.total = e.count
      })
    }
  }
}
</script>
<style lang="less" scoped>
.nowrap {
  white-space: nowrap;
}

.fixtp {
  position: absolute;
  top: -45px;
  right: 20px;
  z-index: 11;

  a {
    margin-left: 20px;
    padding: 0 20px;
    line-height: 30px;
    display: inline-block;
    border-radius: 6px;
    border: #f5222d 1px solid;
    color: #ff4d4f;

    &:hover {
      background: #ff4d4f;
      color: #fff;
    }
  }
}

.welcome {
  position: relative;

  .top {
    @import url('@/assets/css/search.less');
  }

  .tableList {
    margin-top: 20px;
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          // &:nth-last-child(1) {
          //   padding-left: 10px;
          // }

          p {
            padding: 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }

  .pages {
    text-align: right;
  }
}

.change-download {
  .ant-row {
    margin-bottom: 15px;
    line-height: 36px;

    p {
      margin: 0;
    }
  }
}
</style>
